import React, { useEffect, useState,useRef } from 'react';
import { motion } from "framer-motion";
import logisticsImg from "../assets/logistics.webp"; // 📌 Replace with your actual image
import clockImg from "../assets/clock-delivery.png";
import chartImg from "../assets/efficiency-growth.webp";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import customerImg from "../assets/customer-satisfaction.png";

import big from "../assets/Big.webp";

import tick from "../assets/Tick.svg";

import illustration from "../assets/tracking-benefits.webp";
// import a1 from "../assets/A1.png";
// import a2 from "../assets/A2.png";
// import a3 from "../assets/A3.png";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phone from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";
import k1 from "../assets/K1.png";
import k2 from "../assets/K2.png";
import k3 from "../assets/K3.png";
import k4 from "../assets/K4.png";
// import ll from "../assets/LL.png";
import { useNavigate } from 'react-router-dom'; 
import { toast, ToastContainer } from "react-toastify";
 


const Lo = () => {
  const variantss = {
  hiddenLeft: { opacity: 0, x: -30 },
  hiddenRight: { opacity: 0, x: 30 },
  hiddenUp: { opacity: 0, y: -30 },
  hiddenDown: { opacity: 0, y: 30 },
  show: { opacity: 1, x: 0, y: 0, transition: { duration: 0.5 } },
};
 useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // 3s delay
    return () => clearInterval(timer);
  }, []);
   const [data, setData] = useState("");
  const [sessionid, setSessionid] = useState("");
  const [email, setEmail] = useState("");
  const [token, setToken] = useState("");
  useEffect(() => {
    fetch("https://api.app.mawalog.com/v1.2/website")
      .then((response) => response.json())
      .then((json) => {
        setData(json.data.captcha_code);
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      })
      .catch((error) => console.error("Error fetching data:", error));
  }, []);
  useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22); // assuming 'data' holds the captcha string
    }
  }, [data]);
  const handleChange = (e) => {
    setEmail(e.target.value);
  };
 
   const canvasRef = useRef(null);
  const [captchaValue, setCaptchaValue] = useState(""); // text from API
  const [userCaptcha, setUserCaptcha] = useState("");
 
  /* ------------------------------------------------------------------- API fetch */
  const fetchCaptcha = async () => {
    try {
      const res = await fetch(
        "https://api.app.mawalog.com/v1.2/website"
      );
      const json = await res.json();
      setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
    } catch (err) {
      console.error("Error fetching captcha:", err);
    }
  };
 
  /* -- fetch once on mount ------------------------------------------------------- */
  useEffect(() => {
    fetchCaptcha();
  }, []);
 
  /* -- redraw every time captchaValue changes ------------------------------------ */
  useEffect(() => {
    if (!data) return; // nothing to paint yet
    const canvas = canvasRef.current;
    if (!canvas) return;
 
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
 
    /* ========= clear & background */
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
 
    /* ========= random faint bezier curves (extra distortion) */
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random(); // 1-2 px
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
 
    /* ========= characters (uneven) */
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
 
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8; // ±23°
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
 
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
 
    /* ========= dots */
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);
 
  /* -- reload button click ------------------------------------------------------- */
  // const handleReload = () => {
  //   fetch("https://api.app.mawalog.com/v1.2/website")
  //     .then((response) => response.json())
  //     .then((json) => {
  //       setData(json.data.captcha_code);
  //       setSessionid(json.data.session_id);
  //       setToken(json.data.token);
  //     })
  //     .catch((error) => console.error("Error fetching data:", error));
  // };
  //   const handleSubscribe = async () => {
  //   try {
  //     const response = await fetch(
  //       "https://api.app.mawalog.com/v1.2/newsletter",
  //       {
  //         method: "POST",
  //         headers: {
  //           "Content-Type": "application/json",
  //           "X-CSRF-TOKEN": token,
  //         },
  //         body: JSON.stringify({
  //           session_id: sessionid,
  //           captcha: userCaptcha,
  //           email: email,
  //           type: "Mawalog",
  //         }),
  //       }
  //     );
 
  //     const result = await response.json();
  //     console.log("Response:", userCaptcha, " ", data);
  //     setEmail("");
  //    setUserCaptcha("");
  //     toast(result.message);
  //   } catch (error) {
  //     console.error("Error sending request:", error);
  //   }
  // };
const navigate = useNavigate();
 
  const handleClick = () => {
    navigate("/Contact#contact-section");
  };


   const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
     const [isServicesOpen, setIsServicesOpen] = useState(false);
     const [isIndustriesOpen, setIsIndustriesOpen] = useState(false);
     const [isCompanyOpen, setIsCompanyOpen] = useState(false);
   
     const toggleMobileMenu = () => {
       setIsMobileMenuOpen(!isMobileMenuOpen);
     };
   
     const toggleServicesDropdown = () => {
       setIsServicesOpen(!isServicesOpen);
     };
   
     const toggleIndustriesDropdown = () => {
       setIsIndustriesOpen(!isIndustriesOpen);
     };
   
     const toggleCompanyDropdown = () => {
       setIsCompanyOpen(!isCompanyOpen);
     };
   


  const words = ['logistics', 'freight management'];
  
 const [index, setIndex] = useState(0);
  const [fade, setFade] = useState(true); // controls opacity

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 2000); // 1.4s display + 0.6s scroll

    return () => clearInterval(interval);
  }, []);



  const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

 const benefitss = [
  {
    title: "Real-Time Visibility",
    description:
      "Our real-time tracking and monitoring technologies guarantee that businesses are always aware of the location, status, and condition of their shipments.",
    image: clockImg,
  },
  {
    title: "Operational Efficiency",
    description:
      "These efficiency advantages are essential in today's competitive market climate, where dependability, speed, and cost-effectiveness are critical factors.",
    image: chartImg,
  },
  {
    title: "Customer Satisfaction",
    description:
      "Our tracking projects ensure companies meet tight delivery deadlines, provide accurate arrival times, and resolve logistical issues quickly.",
    image: customerImg,
  },
];
  const benefits = [
  "Enhanced visibility and transparency",
  "Improved efficiency and productivity",
  "Cost savings",
  "Better customer services",
  "Enhanced security",
  "Data-driven insights",
];

const transformationDrivers = [
  {
    title: "Digitalization",
    icon: k1,
    description:
      "Digital technologies like automation, AI, and data analytics enhance logistics by improving decision-making, real-time tracking, and supply chain management.",
  },
  {
    title: "Automation",
    icon: k2,
    description:
      "Automation, including robotics and self-driving cars, is transforming logistics by reducing errors and increasing operational efficiency in warehouses.",
  },
  {
    title: "Sustainability",
    icon: k3,
    description:
      "Environmental concerns and regulations drive logistics to adopt sustainable practices like electric vehicles, reusable packaging, and route optimization.",
  },
  {
    title: "Globalization",
    icon: k4,
    description:
      "Global expansion drives demand for international logistics, requiring real-time visibility, compliance, and smarter coordination across borders.",
  },
];

 const drivers = [
    {
      title: "Digitalization",
      icon: k1,
      description:
        "Digital technologies like automation, AI, and data analytics enhance logistics by improving decision-making, real-time tracking, and supply chain management.",
    },
    {
      title: "Automation",
      icon: k2,
      description:
        "Automation, including robotics and self-driving cars, is transforming logistics by reducing errors and increasing operational efficiency in warehouses.",
    },
    {
      title: "Sustainability",
      icon: k3,
      description:
        "Environmental concerns and regulations drive logistics to adopt green practices like eco-friendly packaging, waste reduction, and energy-efficient delivery.",
    },
    {
      title: "Globalization",
      icon: k4,
      description:
        "Global expansion drives demand for international logistics, addressing complex supply chains, cross-border trade, and diverse regulatory challenges.",
    },
  ];
useEffect(() => {
    const interval = setInterval(() => {
      setIndex((prev) => (prev + 1) % words.length);
    }, 3000); // change every 3s
    return () => clearInterval(interval);
  }, []);

//  

//   {
//     title: "Enhanced efficiency",
//     description:
//       "Automation and digital tools are cutting down on  operational expenses, expediting workflows, and eliminating delays. Deliveries become quicker and more dependable as a result, which is advantageous for both customers and companies.",
//   },
//   {
//     title: "Enhanced Visibility",
//     description:
//       "Businesses are able to watch the flow of goods, anticipate disruptions, and make well-informed decisions to reduce risks thanks to real-time tracking and data analytics, which offer a better understanding of the supply chain.",
//   },
//   {
//     title: "Customer Experience",
//     description:
//       "Businesses can provide better customer service, such as precise delivery dates, adaptable shipping alternatives, and quicker answers to queries, by implementing more transparent and efficient logistics processes.",
//   },
//   {
//     title: "Sustainable Practices",
//     description:
//       "As businesses move toward sustainability, they are able to reduce their environmental impact, lower operational costs, and satisfy increasing consumer demand for environmentally friendly goods and services.",
//   },
// ];

const FeatureCard = ({ title, items, bgColor, dotColor }) => (
  <div className={`rounded-2xl p-6 shadow-sm ${bgColor} w-full max-w-md`}>
    <h3 className="font-semibold text-xl mb-4 text-gray-900">{title}</h3>
    <ul className="space-y-3">
      {items.map((item, index) => (
        <li key={index} className="flex items-start gap-3">
          <span className={`mt-1 w-2.5 h-2.5 rounded-full ${dotColor}`}></span>
          <span className="text-sm text-gray-800 leading-snug">{item}</span>
        </li>
      ))}
    </ul>
  </div>
);


 const cardRefs = useRef([]);
const [visible, setVisible] = useState([]);

/* observe cards on scroll (in AND out) */
useEffect(() => {
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        const i = +e.target.dataset.index;
        if (e.isIntersecting) {
          // add index if not already there
          setVisible((prev) => (prev.includes(i) ? prev : [...prev, i]));
        } else {
          // remove index so the animation can run again next time
          setVisible((prev) => prev.filter((v) => v !== i));
        }
      });
    },
    { threshold: 0.15 }
  );

  cardRefs.current.forEach((el) => el && io.observe(el));
  return () => io.disconnect();
}, []);


const variants = {
  hiddenLeft: { opacity: 0, x: -80 },
  hiddenRight: { opacity: 0, x: 80 },
  hiddenUp: { opacity: 0, y: -80 },
  hiddenDown: { opacity: 0, y: 80 },
  show: {
    opacity: 1,
    x: 0,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};


const containerVariants = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.25,   // 0.25 s between cards – tweak as you like
    },
  },
};

/* each card’s own animation ---------------------------------------------------*/
const cardVariants = {
  hidden: { opacity: 0, y: 30 },         // start slightly below & transparent
  show: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.5, ease: "easeOut" },
  },
};

const logisticsBenefits = [
  {
    title: "Enhanced Efficiency",
    description:
      "Automation and digital tools are cutting down on operational expenses, expediting workflows, and eliminating delays. Deliveries become quicker and more dependable as a result, which is advantageous for both customers and companies.",
  },
  {
    title: "Enhanced Visibility",
    description:
      "Businesses are able to watch the flow of goods, anticipate disruptions, and make well-informed decisions to reduce risks thanks to real-time tracking and data analytics, which offer a better understanding of the supply chain.",
  },
  {
    title: "Customer Experience",
    description:
      "Businesses can provide better customer service, such as precise delivery dates, adaptable shipping alternatives, and quicker answers to queries, by implementing more transparent and efficient logistics processes.",
  },
  {
    title: "Sustainable Practices",
    description:
      "Digital logistics promotes eco-friendly practices, such as route optimization and reduced fuel consumption, helping companies reduce their carbon footprint and align with global sustainability goals.",
  },
];
const [isOpen, setIsOpen] = useState(false);

  const toggleSlider = () => {
    setIsOpen((prev) => !prev);
  };
  const benefitsss = [
  "Enhanced visibility and transparency",
  "Improved efficiency and productivity",
  "Cost savings",
  "Better customer services",
  "Enhanced security",
  "Data-driven insights",
];

 // Newsletter captcha refs/state (separate)
  const [submail, setSubmail] = useState("");
  const newsletterCanvasRef = useRef(null);
  const [newsCaptcha, setNewsCaptcha] = useState("");
  const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
  const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");
  const handleReload = () => {
    fetchNewsletterCaptcha();
  };

  const fetchNewsletterCaptcha = async () => {
    try {
      const response = await fetch("https://api.app.mawalog.com/v1.2/website");
      const json = await response.json();
      if (json?.data) {
        setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
      }
    } catch (err) {
      console.error("Error fetching newsletter captcha:", err);
    }
  };

  useEffect(() => {
    // fetch both captchas on mount so both canvases are ready
    fetchNewsletterCaptcha();
  }, []);

  // Draw newsletter captcha whenever it changes
  useEffect(() => {
    if (!newsletterCaptcha?.code) return;
    const canvas = newsletterCanvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;

    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);

    // noise / curves
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.lineWidth = 1 + Math.random();
      ctx.stroke();
    }

    // draw characters
    const chars = newsletterCaptcha.code.toString().split("");
    ctx.fillStyle = "#0A3A72";
    const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 1.2;
      const x = 8 + i * 12 + (Math.random() * 4 - 2);
      const y = 24 + (Math.random() * 6 - 3);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });

    // dots
    for (let i = 0; i < 35; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [newsletterCaptcha]);
    const handleSubscribe = async (e) => {
  e?.preventDefault?.();

  // Basic email validation
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!submail) {
    toast("Please enter an email address");
    return;
  }

  if (!emailRegex.test(submail)) {
    toast("Please enter a valid email address");
    return;
  }

  if (!newsletterUserCaptcha) {
    toast("Please enter the captcha");
    return;
  }

  try {
    const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
      },
      body: JSON.stringify({
        session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
        captcha: newsletterUserCaptcha, // use newsletter captcha input
        email: submail,
        type: "Mawalog",
      }),
    });

    const result = await res.json();

    // On success clear inputs and reload captcha
    if (res.ok) {
      setSubmail("");
      setNewsletterUserCaptcha("");
      fetchNewsletterCaptcha();
    }

    toast(result.message || "Subscription response received");
  } catch (err) {
    console.error("Newsletter subscribe error:", err);
    toast("Subscription failed. Please try again.");
  }
};

  return (
    
    <div >
  



<Helmet>
        <title>Supply Chain & Logistics Solutions | Real-Time Tracking & Operational Efficiency</title>
        <meta name="description" content="MAWALOG adapts to every industry, delImprove visibility, enhance operational efficiency, reduce costs, and deliver superior customer experiences through real-time tracking, automation, digitalization, and sustainable practices.
"/>
        <meta name="keywords" content=" LENTERA logistics services, logistics visibility, customer-centric logistics, global supply chain management.

"/>
      </Helmet>


        
   <section className="bg-[#E0FFE9] font-poppins w-full">
      <div className="max-w-7xl mx-auto flex flex-col-reverse md:flex-row items-center gap-10 px-6 py-16">
        {/* Text Section */}
        <div className="w-full md:w-6/12 text-center md:text-left">
          <p className="text-xs sm:text-sm font-semibold tracking-widest text-gray-900 mb-2">
            SUPPLY CHAIN & LOGISTICS
          </p>

          <h1 className="mb-6 text-3xl sm:text-4xl md:text-5xl font-extrabold text-gray-900 leading-tight">
            Redefining the future
            <br />
            of{" "}
            <span className="inline-block h-[70px] overflow-hidden relative align-middle">
              <div
                className="transition-transform duration-[600ms] ease-in-out"
                style={{ transform: `translateY(-${index * 70}px)` }}
              >
                {words.map((word, i) => (
                  <div
                    key={i}
                    className="h-[70px] flex items-center text-[#07862B] text-[32px] sm:text-[42px] md:text-[48px] font-bold"
                  >
                    {word}
                  </div>
                ))}
              </div>
            </span>
          </h1>

          <p className="text-gray-700 text-sm sm:text-base md:text-lg leading-relaxed max-w-xl mx-auto md:mx-0">
            Third-party integration uses external services and APIs to streamline
            supply chains. In today’s fast-changing logistics industry, digital
            transformation is essential.
          </p>
        </div>

        {/* Image Section */}
        <div className="w-full md:w-6/12 flex justify-center">
          <img
            src={big}
            alt="Global logistics illustration"
            className="w-[90%] max-w-[400px] sm:max-w-[500px] md:max-w-[560px]"
          />
        </div>
      </div>
    </section>

  <section className="w-full bg-white py-16 px-4 md:px-10 font-poppins overflow-hidden">
      {/* Top Heading and Paragraph */}
      <div className="max-w-[800px] mx-auto text-center mb-14">
        <h2 className="text-[36px] sm:text-[42px] lg:text-[48px] font-bold text-[#1A1A1A] leading-tight mb-4">
          Advanced tracking in supply
          <br className="hidden sm:block" /> chain efficiency
        </h2>
        <p className="text-[#3D3D3D] text-[16px] leading-relaxed">
          Advanced tracking uses technology to monitor and optimize supply chains. 
          <br className="hidden md:block" />
           It improves visibility, cuts delays, and reduces costs.
          
        </p>
      </div>

      {/* Card Grid */}
      <div className="max-w-[1440px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
        {benefitss.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
            className="flex flex-col items-center text-center border border-[#d3e1f6] rounded-[24px] bg-white p-8 shadow-sm hover:shadow-md transition-all min-h-[460px]"
          >
            <img
              src={item.image}
              alt={item.title}
              className="w-[348px] h-[208px] object-contain mb-6"
            />
            <h3 className="text-[20px] font-semibold text-[#1E1E1E] mb-4 leading-tight">
              {item.title}
            </h3>
            <p className="text-[#4B5563] text-[16px] leading-[26px]">
              {item.description}
            </p>
          </motion.div>
        ))}
      </div>
    </section>



  <section className="w-full bg-[#1A1A1A] text-white px-4 py-16 sm:px-6 md:px-10 lg:px-24 font-[Poppins]">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-start">
        {/* Left Section */}
        <div>
          <button className="bg-black text-white text-sm font-semibold px-5 py-1.5 rounded-full mb-5">
            BENEFITS OVERVIEW
          </button>

          <h2 className="text-3xl sm:text-4xl md:text-[42px] font-bold leading-tight mb-6">
            Benefits of our tracking <br /> projects
          </h2>

          <p className="text-gray-300 text-base leading-relaxed mb-10">
            Our tracking initiatives provide a number of game-changing advantages that are essential for contemporary freight and logistics management:
          </p>

          {/* Fixed 3x2 Badge Layout — responsive adjustment only */}
          <div className="flex flex-col gap-4">
            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-2 bg-[#3A3A3A] px-7 py-2.5 rounded-full ">
                <img src={tick} alt="tick" className="w-5 h-5" />
                <span className="font-semibold text-white text-sm whitespace-nowrap">
                  Enhanced visibility and transparency
                </span>
              </div>
              <div className="flex items-center gap-2 bg-[#3A3A3A] px-7 py-2.5 rounded-full ">
                <img src={tick} alt="tick" className="w-5 h-5" />
                <span className="font-semibold text-white text-sm whitespace-nowrap">
                  Improved efficiency and productivity
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-2 bg-[#3A3A3A] px-6 py-2.5 rounded-full ">
                <img src={tick} alt="tick" className="w-5 h-5" />
                <span className="font-semibold text-white text-sm whitespace-nowrap">
                  Cost savings
                </span>
              </div>
              <div className="flex items-center gap-4 bg-[#3A3A3A] px-7 py-2.5 rounded-full ">
                <img src={tick} alt="tick" className="w-5 h-5" />
                <span className="font-semibold text-white text-sm whitespace-nowrap">
                  Better customer services
                </span>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row gap-4">
              <div className="flex items-center gap-2 bg-[#3A3A3A] px-5 py-2.5 rounded-full ">
                <img src={tick} alt="tick" className="w-5 h-5" />
                <span className="font-semibold text-white text-sm whitespace-nowrap">
                  Enhanced security
                </span>
              </div>
              <div className="flex items-center gap-2 bg-[#3A3A3A] px-5 py-2.5 rounded-full ">
                <img src={tick} alt="tick" className="w-5 h-5" />
                <span className="font-semibold text-white text-sm whitespace-nowrap">
                  Data-driven insights
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Right Section */}
        <div className="flex justify-center lg:justify-end">
          <img
            src={illustration}
            alt="Tracking illustration"
            className="w-full max-w-[360px] sm:max-w-[420px] md:max-w-[480px] lg:max-w-[400px]"
          />
        </div>
      </div>
    </section>

     <div className="bg-white text-center px-6 py-16 md:px-12">
      <h2 className="text-3xl md:text-5xl font-medium text-[#1A1A1A] leading-snug mb-6">
        Tracking encouraging operational <br className="hidden md:block" />
        excellence
      </h2>
      <p className="text-gray-600 text-[12px] md:text-[15px] max-w-3xl mx-auto">
        Tracking promotes operational excellence by providing real-time data for smarter <br/>  decisions.
        It enhances efficiency, accuracy, and responsiveness across the supply chain.
      </p>
    </div>
<div className="relative bg-white py-16 px-4 sm:px-8 lg:px-20 overflow-hidden -mt-10">
  {/* Background shapes */}
  
  <div className="relative z-10 mx-auto grid max-w-4xl gap-8 md:grid-cols-2">
      {/* 1 — from left */}
     <motion.div
  className="w-[285px] h-[259px] ml-[120px]"
  variants={variants}
  initial="hiddenLeft"
  whileInView="show"
  viewport={{ once: false, amount: 0.3 }}
>
  <FeatureCard
    title="Tracking solutions"
    items={[
      "Commitment to innovation & technology",
      "Reliable tracking solutions",
      "Improved supply chain visibility & efficiency",
      "Enhanced customer satisfaction",
    ]}
    bgColor="bg-rose-100"
    dotColor="bg-rose-400"
  />
</motion.div>


      {/* 2 — from top */}
      <motion.div
      className="w-[408px] h-[218px]"
        variants={variants}
        initial="hiddenUp"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Empowering operational efficiency"
          items={[
            "Accurate and reliable optimization of logistics operations",
            "Real-time shipment status analytics",
            "Proactive decision-making support",
            "Prompt action to minimize disruptions",
          ]}
          bgColor="bg-purple-200"
          dotColor="bg-purple-500"
        />
      </motion.div>

      {/* 3 — from bottom */}
      <motion.div
        className="w-[408px] h-[218px]"
        variants={variants}
        initial="hiddenDown"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Dedication to Superiority"
          items={[
            "Commitment to innovation, scalability, and dependability",
            "Pursuit of operational excellence",
            "Ability to foresee market trends and tackle new challenges",
            "Establishing as a reliable partner in global supply chain optimization",
          ]}
          bgColor="bg-yellow-100"
          dotColor="bg-yellow-400"
        />
      </motion.div>

      {/* 4 — from right */}
      <motion.div
        className="w-[285px] h-[259px]"
        variants={variants}
        initial="hiddenRight"
        whileInView="show"
        viewport={{ once: false, amount: 0.3 }}
      >
        <FeatureCard
          title="Client centric approach"
          items={[
            "Ensure fulfillment of demanding delivery deadlines",
            "Provide clients with precise arrival times",
            "Quickly handle logistical issues",
            "Support reliable tracking through advanced systems",
          ]}
          bgColor="bg-green-100"
          dotColor="bg-green-400"
        />
      </motion.div>
    </div>
    
</div>


       
<section className="bg-[#FFF2B2] py-20 px-4 sm:px-6 lg:px-12">
  {/* Section Heading */}
  <div className="max-w-6xl mx-auto text-center mb-12">
    <h2 className="text-3xl md:text-4xl font-bold text-gray-900">
      Key drivers of transformation
    </h2>
    <p className="mt-4 text-gray-700 max-w-2xl mx-auto text-base md:text-lg">
      Several key factors are driving the transformation of logistics,
      including technological advances, market demands, and evolving customer
      expectations.
    </p>
  </div>

  {/* Grid Cards */}
  <div className="flex flex-wrap justify-center gap-6">
    {transformationDrivers.map((item, idx) => (
      <div
        key={idx}
        className="bg-white rounded-3xl shadow-sm p-6 flex flex-col justify-start w-[520px] h-[237px]"
      >
        <img src={item.icon} alt={item.title} className="w-12 h-12 mb-4" />
        <h3 className="text-lg font-semibold text-gray-900 mb-2">
          {item.title}
        </h3>
        <p className="text-sm text-gray-700 leading-relaxed">
          {item.description}
        </p>
      </div>
    ))}
  </div>
</section>


<section className="w-full bg-white py-16 px-4 md:px-10 font-poppins overflow-hidden">
      <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-10">
        
        {/* Left side: Text + Image */}
        <div className="w-full lg:w-[48%] relative flex flex-col items-center lg:items-start text-center lg:text-left">
          <h2 className="text-[28px] sm:text-[36px] md:text-[44px] font-semibold text-[#1E1E1E] leading-tight mb-6">
            Significantly impact by the logistics transformation
          </h2>
          <p className="text-[#4B5563] text-[16px] sm:text-[18px] leading-[28px] mb-10 max-w-[600px]">
            Logistics transformation is driving major improvements in speed, accuracy, and efficiency across supply chains. It significantly impacts how businesses operate, compete, and deliver value to customers.
          </p>

          {/* Responsive Background Circle (optional) */}
          <div className="absolute top-[50%] left-1/2 -translate-x-1/2 -translate-y-1/2 w-[250px] sm:w-[320px] md:w-[400px] h-auto opacity-20 pointer-events-none z-0">
            {/* <img
              src={bgCircle}
              alt=""
              className="w-full h-auto"
            /> */}
          </div>

          
         {/* Main Logistics Image */}
<div className="relative z-10 w-full max-w-[400px] sm:max-w-[460px] md:max-w-[500px] mx-auto lg:mx-0 flex justify-center items-center">
  <img
    src={logisticsImg}
    alt="Logistics"
    className="w-full h-auto object-contain"
  />
</div>

        </div>

        {/* Right side: Animated cards */}
        <div className="w-full lg:w-[50%] flex flex-col gap-6">
          {logisticsBenefits.map((item, index) => (
            <motion.div
              key={item.title}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              viewport={{ once: false, amount: 0.4 }}
              className="bg-[#F4F9FF] p-5 sm:p-6 rounded-[20px] shadow-sm"
            >
              <h3 className="text-[18px] sm:text-[20px] font-semibold text-[#1E1E1E] mb-2">
                {item.title}
              </h3>
              <p className="text-[#4B5563] text-[15px] sm:text-[16px] leading-[24px] sm:leading-[26px]">
                {item.description}
              </p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>

    <div className="bg-[#111215] text-white">
   {/* Footer Section */}
   <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
     {/* Newsletter Section */}
     <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
            {/* Top newsletter */}
            <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
              {/* Left Side */}
              <div className="flex items-start md:items-center gap-4 md:gap-6">
                <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                  Join our newsletter to <br className="hidden md:block" />
                  keep up to date with us!
                </h2>
              </div>

              <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                {/* Newsletter input */}
                <div
                  className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                  style={{ borderRadius: "6px" }}
                >
                  <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                  <input
                    type="email"
                    value={submail}
                    onChange={(e) => setSubmail(e.target.value)}
                    placeholder="Enter your email"
                    className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                  />
                </div>


                {/* Captcha line (canvas + refresh + input + subscribe button) */}
                {/* Outer wrapper to center the row */}
                <div className="w-full flex justify-center">
                  <div className="flex items-center gap-3">
                    {/* Captcha canvas */}
                    <div className="captcha-box">
                      <canvas
                        ref={newsletterCanvasRef}
                        id="newsletterCaptchaCanvas"
                        width={60}
                        height={40}
                        style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                      />
                    </div>

                    {/* Refresh button */}
                    <button
                      onClick={handleReload}
                      style={{
                        background: "#07862B ",
                        color: "#fff",
                        border: "none",
                        padding: "6px",
                        borderRadius: "6px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                      </svg>
                    </button>

                    {/* Captcha input */}
                    <input
                      type="text"
                      placeholder="Enter captcha"
                      value={newsletterUserCaptcha}
                      onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                      className="captcha-input"
                    />

                    {/* Subscribe button */}
                    <button className="subscribe-button" onClick={handleSubscribe}>
                      Subscribe
                    </button>
                  </div>
                </div>

                <style>{`
  .captcha-box {
    width: 60px !important;
    height: 35px !important;
    border-radius: 6px !important;
    overflow: hidden !important;
    color :131519;
    background-color: #fff !important;
    box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }
 
  .captcha-input {
    padding: 11px 8px !important;
    border-radius: 6px !important;
    border: 1px solid #ccc !important;
    outline: none !important;
    width: 100px !important;
    background: #131519 !important;
    color: #fff !important;
    font-size: 10px !important;
  }
 
  .subscribe-button {
    padding: 10px 16px !important;
    border-radius: 8px !important;
    border: none !important;
    background: #07862B !important;
    color: #fff !important;
    font-weight: bold !important;
    font-size: 13px !important;
    cursor: pointer !important;
    white-space: nowrap !important;
  }
 
  @media(max-width:480px){
    .captcha-input { width: 70px !important; font-size: 12px !important; }
    .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
  }
`}</style>

              </div>
            </div>

            {/* Divider */}
            <div className="border-t border-gray-700 w-full" />

            {/* Main Footer Content */}
            <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
              {/* Company Info */}
              <div className="w-full lg:w-[30%]">
                <a href="/" aria-label="Lentera Home">
                  <img src={nlen} alt="Lentera logo" className="mb-6" />
                </a>
                <p className="text-[#d4d4d4] leading-relaxed">
                  We are highly experienced in offering software development, mobile
                  application development, software consulting and project management
                  delivery.
                </p>
                {/* Social Icons */}
                <div className="flex gap-4 mt-6 flex-wrap">
                  <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                    <img src={inst} alt="Instagram" className="w-8 h-8" />
                  </a>
                  <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                    <img src={face} alt="Facebook" className="w-8 h-8" />
                  </a>
                  <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={you} alt="YouTube" className="w-8 h-8" />
                  </a>
                  <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                    <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                  </a>
                  <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                    <img src={twi} alt="X" className="w-8 h-8" />
                  </a>
                </div>

              </div>

              {/* Services */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                  <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                  <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                  <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                  <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                  <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                  <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                </ul>
              </div>


              {/* Insights */}
              <div className="w-full sm:w-[45%] md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                <ul className="space-y-2 text-[#d4d4d4]">
                  <li><Link to="/blogs" className="hover:text-white">Blog</Link></li>
                  <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                  <li><Link to="/blogs" className="hover:text-white">News</Link></li>
                </ul>
              </div>

              {/* Contact */}
              <div className="w-full md:w-auto">
                <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                <div className="flex items-start gap-3 mb-3">
                  <img src={phone} alt="phone" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Phone number</p>
                    <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                      +91-44-4856-3345
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3 mb-3">
                  <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Email address</p>
                    <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                      info@lenteratech.com
                    </a>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                  <div>
                    <p className="text-[#999] text-sm">Location</p>
                    <a
                      href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-white font-medium text-sm hover:underline block"
                    >
                      G1, Plot No, 824 and 826, 3rd<br />
                      Main Rd, Ram Nagar South,<br />
                      Madipakkam, Chennai,<br />
                      Tamil Nadu 600091
                    </a>
                  </div>
                </div>


              </div>
            </div>
          </div>
   </footer>
 
   {/* Bottom Section */}
   <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
     <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
     <div className="flex flex-wrap gap-4 justify-center md:justify-end">
       <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
       <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
       <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
       <a href="/copyright-information/" className="hover:underline">Copyright information</a>
     </div>
   </div>
 </div>

    </div>
  )
}

export default Lo